export default "__VITE_ASSET__DLwtoLCx__"